import auth from './Auth/auth';
import user from './User/user';
import email from './Email/email';

const LuxtagApi = {
  auth: auth,
  user: user,
  email: email,
};

export default LuxtagApi;



// WEBPACK FOOTER //
// ./src/API/index.js